<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title" title="TaxDeclare">个税申报</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="onUpdate"
        v-if="$judge_auth('78')"
      >
        更新申报结果
      </el-button>
      <!-- <el-button
        type="warning"
        link
        icon="Tickets"
        @click="onSubmit"
        v-if="$judge_auth('77')"
      >
        批量申报
      </el-button> -->
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click="onLock"
        v-if="$judge_auth('80')"
      >
        批量锁定
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click="onUnLock"
        v-if="$judge_auth('81')"
      >
        批量解锁
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        size="large"
        v-if="$judge_auth('637')"
        >导出
      </el-button>
      <el-button
        type="primary"
        :icon="Search"
        link
        @click="state.showSearch = true"
        size="large"
        v-if="$judge_auth('593')"
        >全渠道申报状态査询
      </el-button>
    </ul>
    <ul class="c-list-search">
      <div style="flex: 2; display: flex; flex-wrap: wrap; gap: 10px">
        <el-radio-group v-model="state.params.status" @change="onLoad">
          <el-radio-button :value="0">未申报</el-radio-button>
          <el-radio-button :value="1">已申报</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="state.params.tax_month"
          type="month"
          placeholder="税款所属月份"
          value-format="YYYY-MM"
          format="YYYY年M月"
          style="width: 140px"
        />
        <div
          class="c-withholdingagent-search-box"
          @click="state.showWithholdingAgent = true"
        >
          <li style="flex: 1; display: flex; column-gap: 5px">
            <template v-if="state.withholding_agent_arr?.length > 0">
              <div
                class="c-withholdingagent-search-tag"
                style="
                  max-width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ state.withholding_agent_arr[0]?.name }}
              </div>
              <el-popover
                v-if="state.withholding_agent_arr?.length > 1"
                placement="right"
                width="auto"
                popper-style="max-height: 90vh;overflow-y: auto;"
              >
                <template #reference>
                  <div class="c-withholdingagent-search-tag" @click.stop="">
                    {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                  </div>
                </template>
                <template #default>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      row-gap: 5px;
                      width: fit-content;
                    "
                  >
                    <ul
                      v-for="(item, index) in state.withholding_agent_arr"
                      :key="item"
                      style="
                        white-space: nowrap;
                        background-color: #f0f2f5;
                        color: var(--el-color-info);
                        border-radius: 4px;
                        font-size: 12px;
                        padding: 0 9px;
                        height: 24px;
                        line-height: 24px;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                      "
                    >
                      <li>{{ item.name }}</li>
                      <el-icon
                        @click.stop="
                          state.withholding_agent_arr.splice(index, 1)
                        "
                        color="#a2a2a2"
                        style="cursor: pointer"
                        ><CircleClose
                      /></el-icon>
                    </ul>
                  </div>
                </template>
              </el-popover>
            </template>
            <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
          </li>
          <el-icon
            v-if="state.withholding_agent_arr?.length > 0"
            @click.stop="delete state.withholding_agent_arr"
            color="#a2a2a2"
            ><CircleClose
          /></el-icon>
        </div>
        <el-select
          v-model="state.params.tax_bureau_id"
          placeholder="税局"
          style="width: 260px"
        >
          <el-option
            v-for="item in state.taxbureau_data"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadTaxBureau()">
              刷新
            </el-button>
          </template>
        </el-select>
        <el-select
          v-model="state.params.declare_type"
          placeholder="申报类型"
          style="width: 120px"
        >
          <el-option
            v-for="item in $constant.taxdeclare_declare_type"
            :key="item.Key"
            :label="item.Text"
            :value="item.Key"
          />
        </el-select>
        <el-select
          v-model="state.params.declare_kind"
          placeholder="申报种类"
          style="width: 120px"
        >
          <el-option label="正常申报" value="正常申报" />
          <el-option label="更正申报" value="更正申报" />
        </el-select>
        <el-config-provider
          :value-on-clear="null"
          :empty-values="[undefined, null]"
        >
          <el-select
            v-model="state.params.lock_status"
            placeholder="锁定状态"
            style="width: 120px"
          >
            <el-option label="未锁定" :value="0" />
            <el-option label="已锁定" :value="1" />
          </el-select>
        </el-config-provider>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          column-gap: 10px;
          padding: 0 30px;
        "
      >
        <li style="text-align: center; min-width: 80px">
          <div style="color: #1e90ff; font-size: 18px">
            {{ state.statistics?._total || 0 }}
          </div>
          <text style="font-size: 80%; color: #a2a2a2">计薪人数</text>
        </li>
        <li style="text-align: center; min-width: 120px">
          <c_statistics :value="state.statistics?.income_amount" color="#080" />
          <text style="font-size: 80%; color: #a2a2a2">本期收入总额</text>
        </li>
        <li style="text-align: center; min-width: 120px">
          <c_statistics
            :value="state.statistics?.net_salary"
            color="#f00"
            bold
          />
          <text style="font-size: 80%; color: #a2a2a2">实发工资总额</text>
        </li>
        <li style="text-align: center; min-width: 120px">
          <c_statistics
            :value="state.statistics?.tax_refund_amount"
            color="#ffa500"
          />
          <text style="font-size: 80%; color: #a2a2a2">个税金额</text>
        </li>
      </div>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
        border
        class="tax-declare-table"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          width="200"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="declare_type_name"
          sortable="declare_type"
          label="所得税类型"
          :formatter="$tab_TextFormat"
          min-width="120"
        />
        <el-table-column
          prop="declare_status_name"
          sortable="declare_status"
          label="申报状态"
          width="140"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="taxpayer_num"
          sortable="taxpayer_num"
          label="纳税人数"
          :formatter="$tab_NumberFormat"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="reportable_num"
          sortable="reportable_num"
          label="应申报人数"
          :formatter="$tab_NumberFormat"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="income_amount"
          sortable="income_amount"
          label="本期收入总额"
          :formatter="$tab_PriceFormat"
          min-width="120"
          align="center"
        >
          <template #default="{ row }">
            <el-popover
              width="60%"
              trigger="hover"
              @before-enter="onLoadChildren(row)"
            >
              <template #reference>
                <text
                  style="color: #1e90ff"
                  class="text-hover-decoration"
                  title="本期收入总额"
                >
                  {{ row.income_amount }}
                </text>
              </template>
              <template #default>
                <el-table
                  :data="row.children"
                  v-loading="!Array.isArray(row.children)"
                  element-loading-background="rgba(0, 0, 0, 0.2)"
                >
                  <el-table-column
                    prop="sdlx"
                    label="所得类型"
                    :formatter="$tab_TextFormat"
                    align="center"
                  >
                    <template #default="scoped">
                      <text
                        style="color: #1e90ff"
                        class="text-hover-decoration"
                        title="所得类型"
                        @click="
                          state.row_id = row.id;
                          state.selectItem = scoped.row;
                          state.showRecord = true;
                        "
                      >
                        {{ scoped.row.d_tax_type_name }}
                      </text>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="taxpayer_num"
                    label="纳税人数"
                    :formatter="$tab_NumberFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="reportable_num"
                    label="应申报人数"
                    :formatter="$tab_NumberFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="income_amount"
                    label="本期收入总额"
                    :formatter="$tab_PriceFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="payable_tax_amount"
                    label="累计应扣缴额"
                    :formatter="$tab_PriceFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="paied_tax_amount"
                    label="累计已扣缴额"
                    :formatter="$tab_PriceFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="tax_refund_amount"
                    label="本期应补(退)税额"
                    :formatter="$tab_PriceFormat"
                    align="center"
                  />
                </el-table>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="payable_tax_amount"
          sortable="payable_tax_amount"
          label="累计应扣缴额"
          :formatter="$tab_PriceFormat"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="paied_tax_amount"
          sortable="paied_tax_amount"
          label="累计已扣缴额"
          :formatter="$tab_PriceFormat"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="tax_refund_amount"
          sortable="tax_refund_amount"
          label="本期应补(退)总额"
          :formatter="$tab_PriceFormat"
          min-width="160"
          align="center"
        />
        <el-table-column label="附表" min-width="140">
          <template #default="{ row }">
            <template v-if="row.is_attached == 1">
              <text
                style="cursor: pointer"
                :style="{
                  color: row.attached_status == 1 ? '#080' : '#1e90ff',
                }"
                @click.stop="
                  state.selectItem = row;
                  state.showAttached = true;
                "
              >
                {{ row.attached_status == 1 ? "已填写" : "未填写" }}
              </text>
            </template>
            <text v-else>无需填写</text>
            <!-- <text
                style="color: #1e90ff; cursor: pointer"
                @click="
                  state.selectItem = row;
                  state.showAttached = true;
                "
              >
                未填写
              </text> -->
          </template>
        </el-table-column>
        <el-table-column prop="declare_type" label="申报类型" min-width="140">
          <template #default="{ row }">
            <c_status
              arr-name="taxdeclare_declare_type"
              :value="row.declare_type"
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          label="锁定状态"
          :formatter="$tab_TextFormat"
          min-width="120"
          align="center"
        >
          <template #default="{ row }">
            <text :style="{ color: row.lock_status ? '#080' : '#f00' }">{{
              row.lock_status ? "已锁定" : "未锁定"
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="declare_time"
          label="申报时间"
          :formatter="$tab_TextFormat"
          width="120"
          align="center"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          min-width="180"
        />
        <el-table-column label="错误信息" min-width="240">
          <template #default="{ row }">
            <div style="display: flex">
              <el-tooltip v-if="row.declare_msg_detail" placement="left">
                <el-icon style="margin-left: 5px; cursor: pointer">
                  <QuestionFilled />
                </el-icon>
                <template #content>
                  <div
                    v-html="row.declare_msg_detail"
                    style="
                      max-width: 60vw;
                      max-height: 80vh;
                      overflow-y: auto;
                      cursor: pointer;
                    "
                    @click="$onCopy(row.declare_msg_detail)"
                  ></div>
                </template>
              </el-tooltip>
              <div v-html="row.declare_msg || '-'"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          v-if="$judge_auth(['77', '587'])"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Upload"
              @click.stop="onSingleSubmit(row)"
              v-if="
                ['1', '3'].includes(row.declare_status) && $judge_auth('77')
              "
            >
              申报
            </el-button>
            <el-button
              type="danger"
              link
              icon="Close"
              @click.stop="onCancel(row)"
              v-if="
                ['5', '6'].includes(row.declare_status) && $judge_auth('587')
              "
            >
              作废
            </el-button>
            <text
              v-if="
                !(
                  ['1', '3', '5', '6'].includes(row.declare_status) &&
                  $judge_auth(['77', '587'])
                )
              "
              >-
            </text>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showRecord"
        :title="state.selectItem.d_tax_type_name"
        @close="state.showRecord = false"
        style="z-index: 2025"
      >
        <c_TaxDeclareRecord
          :tax_declare_id="state.row_id"
          :tax_declare_type_stat_id="state.selectItem.id"
          v-if="state.showRecord"
        ></c_TaxDeclareRecord>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showAttached" title="填写附表" size="80%">
      <template #header>
        <div style="display: flex; align-items: center">
          <text>填写附表</text>
          <li style="margin-left: 20px; font-size: 13px; color: #ffa500">
            2019年1月起在所得项目中填写了对应值后，需填写附表，才可进行个税申报
          </li>
        </div>
      </template>
      <c_TaxDeclareAttached
        v-if="state.showAttached"
        :item="state.selectItem"
      ></c_TaxDeclareAttached>
    </el-drawer>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              console.log(arr);

              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-fade-in-linear">
      <c_dialog
        title="全渠道申报状态査询"
        v-if="state.showSearch"
        @close="state.showSearch = false"
        width="400px"
      >
        <el-form
          label-position="top"
          :model="state.searchModel"
          style="padding: 10px"
          ref="formDom"
        >
          <el-form-item
            label="税款所属期"
            prop="tax_month"
            :rules="[
              {
                required: true,
                message: '请选择税款所属期',
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="state.searchModel.tax_month"
              type="month"
              placeholder="税款所属期"
              style="width: 100%"
              value-format="YYYY-MM"
            />
          </el-form-item>
          <el-form-item
            label="扣缴义务人"
            prop="withholding_agent"
            :rules="[
              {
                required: true,
                message: '请选择扣缴义务人',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.searchModel.withholding_agent"
              placeholder="选择扣缴义务人"
              value-key="id"
            >
              <el-option
                v-for="item in state.withholding_agent_data"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
              <template #footer>
                <el-button size="small" @click="onLoadWithholdingAgent()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onShowSearchList"
              style="width: 100%"
              icon="Search"
            >
              确定查询
            </el-button>
          </el-form-item>
        </el-form>
      </c_dialog>
    </transition>
    <transition name="el-fade-in-linear">
      <c_dialog
        :title="`全渠道申报状态查询结果 —— ${state.searchModel?.withholding_agent?.name}`"
        v-if="state.showSearchList"
        @close="state.showSearchList = false"
        width="100%"
        z-index="999"
      >
        <div style="overflow-y: auto; flex: 1; padding: 10px">
          <div
            style="padding: 10px; border-radius: 8px; background-color: #ecf5fd"
          >
            <ul style="font-weight: 600; font-size: 120%">
              {{
                state.searchModel.tax_month
              }}
            </ul>
            <ul>
              {{
                state.searchModel?.withholding_agent?.name
              }}
            </ul>
          </div>
          <div style="border-radius: 10px; overflow: hidden">
            <table
              cellpadding="10"
              border="1"
              style="
                border-collapse: collapse;
                width: 100%;
                border-color: #e2e2e2;
                text-align: center;
                margin-top: 10px;
                border-radius: 8px;
              "
            >
              <thead>
                <tr style="background-color: #f3f4f6">
                  <th v-for="item in state.searchFields" :key="item">
                    {{ item.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tr in state.searchList" :key="tr">
                  <td v-for="td in state.searchFields" :key="td">
                    {{ tr[td.field] || "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </c_dialog>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_taxbureau_select } from "@/http/data";
import {
  taxdeclare_list,
  taxdeclare_getstatistics,
  taxdeclare_list_children,
  taxdeclare_update,
  taxdeclare_doDeclares,
  taxdeclare_lock,
  taxdeclare_unlock,
  taxdeclare_cancel,
  taxdeclare_export,
  taxdeclare_querydeclarationrecord,
} from "@/http/taxdeclare";
import { ElMessage, ElMessageBox, dayjs } from "element-plus";
import { data_withholdingagent_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 100,
    page: 1,
    status: 0,
  };
}
export default {
  props: {
    data: Object,
  },
  setup(props) {
    const formDom = ref(null);
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      searchModel: {},
    });
    onMounted(() => {
      if (props.data?.tax_month) {
        state.params.tax_month = dayjs(
          props.data?.tax_month?.toString(),
        ).format("YYYY-MM");
      } else
        state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");

      if (props.data?.withholding_agent)
        state.withholding_agent_arr = [props.data?.withholding_agent];

      onLoadTaxBureau();
      onLoadWithholdingAgent();
      state.tableData = [];
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      taxdeclare_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });

      taxdeclare_getstatistics(state.params).then((res) => {
        if (res.status == 200) {
          state.statistics = res.data.data;
        }
      });
    };

    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200) {
          state.withholding_agent_data = res.data.data?.list;
        }
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    const onLoadChildren = (row) => {
      if (row.children?.length > 0) return false;

      taxdeclare_list_children({ tax_declare_id: row.id }).then((res) => {
        if (res.status == 200) row.children = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //从税局更新数据确认事件
    const onSelectConfirm = () => {
      state.showAgent = false;
      onLoad();
    };

    //批量更新
    const onUpdate = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即<strong style='color:#ffa500'>更新已选扣缴义务人的申报结果</strong>？`,
        "更新申报结果",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即更新",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        taxdeclare_update(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //单个申报
    const onSingleSubmit = (row) => {
      ElMessageBox.confirm(
        `您确定要提交企业<strong style='color:#1e90ff'>${row.withholding_agent_name}</strong>的申报请求吗？`,
        "提交申报",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即申报",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        taxdeclare_doDeclares(row.id).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //批量申报
    const onSubmit = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即提交<strong style='color:#1e90ff'>申报</strong>？`,
        "提交申报",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即申报",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        taxdeclare_doDeclares(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //批量锁定
    const onLock = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即<strong style='color:#ffa500'>锁定已选扣缴义务人</strong>？`,
        "锁定",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即锁定",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        taxdeclare_lock(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //批量解锁
    const onUnLock = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即<strong style='color:#080'>解锁已选扣缴义务人</strong>？`,
        "更新申报结果",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即更新",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        taxdeclare_unlock(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //申报作废
    const onCancel = (row) => {
      ElMessageBox.confirm(
        `您确定要<strong style='color:#f00'>作废</strong>企业<strong style='color:#1e90ff'>${row.withholding_agent_name}</strong>的申报请求吗？`,
        "提交申报",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定作废",
          cancelButtonText: "取消",
          confirmButtonClass: "el-button--danger",
          type: "warning",
        },
      ).then(() => {
        taxdeclare_cancel(row.id).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      taxdeclare_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const onShowSearchList = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.showSearchList = true;
          onSearchList();
        }
      });
    };

    const onSearchList = () => {
      taxdeclare_querydeclarationrecord({
        tax_month: state.searchModel.tax_month,
        withholding_agent_id: state.searchModel.withholding_agent?.id,
      }).then((res) => {
        if (res.status == 200) {
          const { list, sortFields } = res.data.data;
          state.searchList = list;
          state.searchFields = sortFields;
        }
      });
    };

    return {
      state,
      tableDom,
      formDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadTaxBureau,
      onRowClick,
      onSelectConfirm,
      onLoadChildren,
      onUpdate,
      onSingleSubmit,
      onSubmit,
      onLock,
      onUnLock,
      onCancel,
      onExport,
      onLoadWithholdingAgent,
      onShowSearchList,
      onSearchList,
    };
  },
};
</script>
<style lang="less">
.tax-declare-table {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;

  .el-table__header tr th {
    background-color: #f6f6f6 !important;
    border-right: 1px solid #e2e2e2 !important;
  }

  /* 移除表体的网格线 */
  .el-table__body tr td {
    border-right: none !important; /* 移除所有边框 */
  }
}
</style>
